
import Layout from '@/layout'

const technicalSupportRouter = {
  path: '/technicalSupport',
  component: Layout,
  name: 'sparePartsAnnouncement',
  meta: {
    title: '技术支持',
    icon: 'frame31',
    code: 'support'
  },
  children: [
    // 备件公告
    {
      path: 'sparePartsAnnouncement',
      component: () => import('@/views/technicalSupport/sparePartsAnnouncement'),
      name: 'SparePartsAnnouncement',
      meta: { title: 'routeSparePartsAnnouncement', icon: 'zlgg', code: 'support:notice:page' }
    },
    // 技术质量问题反馈
    {
      path: 'feedbackOnQualityIssues',
      component: () => import('@/views/technicalSupport/feedbackOnQualityIssues'),
      name: 'FeedbackOnQualityIssues',
      meta: { title: 'routeFeedbackOnQualityIssues', icon: 'frame16', code: 'support:feedback:page' }
    },
    // 我的-技术质量问题反馈详情
    {
      path: 'partAdviceInfo/:id',
      component: () => import('@/views/technicalSupport/partAdviceInfo'),
      name: 'PartAdviceInfo',
      meta: { title: 'routeFeedbackOnQualityIssuesDetails', icon: 'clipboard', noCache: true, activeMenu: '/views/technicalSupport/partAdviceInfo', code: 'support:feedback:page' },
      hidden: true
    },
    // 技术质量问题反馈管理列表
    {
      path: 'partsAdviceList',
      component: () => import('@/views/technicalSupport/partsAdviceList'),
      name: 'PartsAdviceList',
      meta: { title: 'routeFeedbackOnQualityIssuesList', icon: 'frame16', code: 'support:feedback:issue' },
      hidden: true
    },
    // 技术质量问题反馈详情
    {
      path: 'partAdviceAdminInfo/:id',
      component: () => import('@/views/technicalSupport/partAdviceAdminInfo'),
      name: 'PartAdviceAdminInfo',
      meta: { title: 'routeFeedbackOnQualityIssuesDetails', icon: 'clipboard', noCache: true, activeMenu: '/views/technicalSupport/partAdviceAdminInfo', code: 'support:feedback:issue' },
      hidden: true
    },
    // 已解决问题列表
    {
      path: 'partsAdviceResolvedList',
      component: () => import('@/views/technicalSupport/partsAdviceResolvedList'),
      name: 'PartsAdviceResolvedList',
      meta: { title: 'routeResolvedManagement', icon: 'frame16', code: 'support:feedback:issue' },
      hidden: true
    },
    // 市场处置
    {
        path: 'marketDisposal',
        component: () => import('@/views/technicalSupport/marketDisposal'),
        name: 'MarketDisposal',
        meta: { title: 'routeMarketDisposal', icon: 'sccz', code: 'support:handel:page' }
    },
    // 技术通告
    {
        path: 'technicalCircular',
        component: () => import('@/views/technicalSupport/technicalCircular'),
        name: 'TechnicalCircular',
        meta: { title: 'routeTechnicalCircular', icon: 'jstg', code: 'support:inform:page' }
    },
    // 知识库
    {
        path: 'knowledge',
        component: () => import('@/views/technicalSupport/knowledge'),
        name: 'Knowledge',
        meta: { title: 'routeKnowledge', icon: 'zsk', code: 'support:base:page' }
    },
    // 维修案例反馈
    {
      path: 'maintainFeedBack',
      component: () => import('@/views/technicalSupport/maintainFeedBack'),
      name: 'MaintainFeedBack',
      meta: { title: 'routeMaintainFeedBack', icon: 'frame29', code: 'support:case:page' }
    },
    // 维修反馈管理列表
    {
      path: 'sysFeedBack',
      component: () => import('@/views/technicalSupport/sysFeedBack'),
      name: 'SysFeedBack',
      meta: { title: 'routeSysFeedBack', icon: 'frame17', code: 'support:case:backlist' },
      hidden: true
    }
  ]
}

export default technicalSupportRouter
